module.exports = __webpack_public_path__ + "static/media/mytutor-logo.ba0139ac.svg";